'use client';

import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requirePropTypes } from "../external/prop-types/index.js";
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
export {
  PropTypes as default
};
